import React from 'react';
import PropTypes from 'prop-types';
import { SuiContainer } from '@splashthat/sui';

import Close from 'common/icons/CloseForm';
import Spacer from 'common/components/Spacer';
import { containerPaddingM } from 'common/styles/variables';

import { WorkspaceTopbar } from '../Topbar';
import { StyledCloseIcon, ButtonSeparator, TopbarPreview } from './Topbar.styles';

const BASE_CLASS_NAME = 'WorkspaceTopbarPreview';

export default function WorkspaceTopbarPreview({
    title,
    topbarLeftContent,
    topbarCenterContent,
    topbarRightContent,
    backPath,
}) {
    return (
        <WorkspaceTopbar className={`${BASE_CLASS_NAME}__topbar`} useLightMode>
            <TopbarPreview className={`${BASE_CLASS_NAME}__topbar-container`} variation="full-height full-width">
                <SuiContainer variation="flex-horizontal flex-horizontal-left">
                    {topbarLeftContent ? (
                        <>
                            <WorkspaceTopbar.Title title={title} headerStyles={{ margin: 0 }} />
                            <Spacer $spacingY={containerPaddingM} />
                            {topbarLeftContent}
                        </>
                    ) : (
                        <WorkspaceTopbar.Title title={title} />
                    )}
                </SuiContainer>

                <SuiContainer variation="flex-horizontal">{topbarCenterContent}</SuiContainer>

                <SuiContainer variation="flex-horizontal flex-horizontal-right">
                    {topbarRightContent && (
                        <>
                            {topbarRightContent}
                            <ButtonSeparator />
                        </>
                    )}
                    <StyledCloseIcon aria-label="Close Preview" replace to={backPath}>
                        <Close />
                    </StyledCloseIcon>
                </SuiContainer>
            </TopbarPreview>
        </WorkspaceTopbar>
    );
}

WorkspaceTopbarPreview.propTypes = {
    topbarLeftContent: PropTypes.node,
    topbarCenterContent: PropTypes.node,
    topbarRightContent: PropTypes.node,
    backPath: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

WorkspaceTopbarPreview.defaultProps = {
    topbarLeftContent: null,
    topbarCenterContent: null,
    topbarRightContent: null,
};
